// var $window = $(window);
// var breakPoint = 768;
//
// var resizeFlag = false;
// var windowWidth = $window.width();
// var windowHeight = $window.height();

//anchorLink
import {anchorLink} from "../include/module";
anchorLink();

//preload
import {preload} from "../include/module";
preload();

//checkSP
import {checkSP} from "../include/module";
checkSP();

//bgAnime
import {bgAnime} from "../include/module";
bgAnime();

//toggleHeader
import {toggleHeader} from "../include/module";
toggleHeader();

//pageTop
import {pageTop} from "../include/module";
pageTop();


//showTtl
import {showTtl} from "../include/module";
showTtl();



$(document).ready(function(){
  storySlide();
});

// ------------------------------------------------------------------------
// storySlide
// ----- BOTH
// ------------------------------------------------------------------------
const storySlide = () => {

  var storySwiper;
  storySwiper = new Swiper('.story-List_Item_Img', {
    watchOverflow: true,
    slidesPerView: 3,
    // loopedSlides: 2,
    spaceBetween: 8,
    autoplay: {delay: 5000},
    speed: 500,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    // loop: true,
    breakpoints: {
      767: {
        // loop: !hasOneSlide,
        slidesPerView: 1,
        grabCursor: true,
      }
    },
  });


  // var lastInnerWidth = window.innerWidth;
  // $(window).on('resize' , function() {
  //   // 現在と前回の横幅が違う場合だけ実行
  //   var innerW = window.innerWidth;
  //   if ( lastInnerWidth != innerW ) {
  //     if (innerW < 768 ) {
  //       storySwiper.params.slidesPerView = 1;
  //       // console.log('sp')
  //     } else  {
  //       storySwiper.params.slidesPerView = 3;
  //       // console.log('pc')
  //     }
  //      var prm = storySwiper.params;     // パラメータを保存
  //      storySwiper.destroy( true, true );     // 削除
  //      storySwiper = new Swiper ('.story-List_Item_Img', prm );     // 再設定
  //      lastInnerWidth = window.innerWidth;
  //   };
  // });

};



// WEBPACK FOOTER //
// ./src/bangdream_3rd_v0/assets/js/story/script.js